export class AssetAmount {
    constructor(asset, amount) {
        this.asset = asset;
        this.amount = amount;
    }
    static fromToken(token) {
        return new this({
            id: token.tokenId,
            name: token.name,
            decimals: token.decimals
        }, token.amount);
    }
    withAmount(amount) {
        return new AssetAmount(this.asset, amount);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzZXRBbW91bnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZXJnby9lbnRpdGllcy9hc3NldEFtb3VudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxNQUFNLE9BQU8sV0FBVztJQUN0QixZQUE0QixLQUFnQixFQUFrQixNQUFjO1FBQWhELFVBQUssR0FBTCxLQUFLLENBQVc7UUFBa0IsV0FBTSxHQUFOLE1BQU0sQ0FBUTtJQUFHLENBQUM7SUFFaEYsTUFBTSxDQUFDLFNBQVMsQ0FBQyxLQUFrQjtRQUNqQyxPQUFPLElBQUksSUFBSSxDQUNiO1lBQ0UsRUFBRSxFQUFFLEtBQUssQ0FBQyxPQUFPO1lBQ2pCLElBQUksRUFBRSxLQUFLLENBQUMsSUFBSTtZQUNoQixRQUFRLEVBQUUsS0FBSyxDQUFDLFFBQVE7U0FDekIsRUFDRCxLQUFLLENBQUMsTUFBTSxDQUNiLENBQUE7SUFDSCxDQUFDO0lBRUQsVUFBVSxDQUFDLE1BQWM7UUFDdkIsT0FBTyxJQUFJLFdBQVcsQ0FBQyxJQUFJLENBQUMsS0FBSyxFQUFFLE1BQU0sQ0FBQyxDQUFBO0lBQzVDLENBQUM7Q0FDRiJ9